/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { colors } from "./colors";
import { effects } from "./effects";

const labelStyle = css`
  display: flex;
  flex-direction: row;
  padding: 6px 12px;
  align-items: center;
  gap: 8px;
  height: hug-content;
  align-items: center;
  border-radius: 9999px;
  text-decoration: none;
  background: ${colors.white};
  box-shadow: ${effects.label};
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const BadgeBase = ({ children, ...rest }: Props) => {
  return (
    <div css={labelStyle} {...rest}>
      {children}
    </div>
  );
};
